import { Component, OnInit } from '@angular/core';

import { AppInformationService, ArkUnitOfWork, AuthService, DataService } from 'app/core/core.module';
import { EntityQuery } from 'breeze-client';
import { DevExtremeModule } from 'devextreme-angular';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-general-fund-dialog',
    templateUrl: './general-fund-dialog.component.html',
    styleUrls: ['./general-fund-dialog.component.scss'],
    imports: [DevExtremeModule],
    standalone: true,
})
export class GeneralFundDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    routerOption: any;

    generalFund: any;
    data: any;
    executive: any;
    thanksgiving: boolean;


    constructor(
        public modalRef: BsModalRef,
        private uow: ArkUnitOfWork,
        private appInfo: AppInformationService,
        private dataService: DataService,
        private auth: AuthService
    ) {}

    async ngOnInit() {
        this.executive = (this.auth.hasRole('Executive') && !this.auth.hasRole('Administrator'));

        if (!this.thanksgiving) {
        const startDate = new Date(this.data.year, this.data.monthInt - 1, 1);
        const endDate = new Date(this.data.year, this.data.monthInt, 1);
        // console.log(startDate);
        // console.log(endDate);

        const query = EntityQuery.from('GeneralFundDrillDown').withParameters({ startDate: startDate, endDate: endDate });

        // const query = EntityQuery.from('BatchesList')
        //     .where('date', '>=', startDate)
        //     .where('date', '<=', endDate)
        //     .where('quickBooksAccount', '==', '3010');
        const data = await this.uow.manager.executeQuery(query);
        this.generalFund = data.results;
        } else {
            const query = EntityQuery.from('ThanksgivingDetail').withParameters({ year: this.data.year });
            const data = await this.uow.manager.executeQuery(query);
            let i = 1;
            data.results.forEach(x => {
                x.id = i++;
                x.name = x.accountName;
            });
            this.generalFund = data.results;
        }
        // console.log(this.generalFund);
        // this.contributions = []; // (await this.uow.getContributions(this.batchId)) as any[];
        // // const contribution = this.uow.manager.createEntity('Contribution', { batchId: this.batchId, created: new Date(Date.now()) }) as Contribution;
        // this.people = await this.uow.getPeopleForGiving();
        // // console.log(this.people);
        // this.types = await this.uow.getContributionTypes();
        // this.otherAccounts = this.uow.otherAccounts();

        // this.contribution = new ContributionItem();
        // this.contribution.accountId = this.specialAccountId;
        // this.contribution.givingTypeId = 1;
        // this.contribution = { accountId: this.specialAccountId, givingTypeId: 1, personId: 0, amount: 0, timeStamp: new Date() };
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            template: 'toolbarButtons'
        });
    }

    close() {
        this.result.next({ result: false });
    }
}
class ContributionItem {
    id: number;
    accountId: number;
    givingTypeId: number;
    givingName: string;
    personName: string;
    personId: number;
    amount: number;
    timeStamp: Date;
    envelope: any;

    constructor() {}
}
